/**
 * SupportPage class handles various functionalities related to the support page.
 *
 * Example script tag to add to the support page:
 *
 * <script
 *   id="supportPageScript"
 *   defer
 *   src="https://angular-crm-widgets-test.s3.eu-west-1.amazonaws.com/support/v1/handler.min.js"
 *   data-outlet-key="STE"
 *   data-api-base-url="https://api.angular-test.puraido.dev"
 * >
 *
 */
class SupportFormHandler {
    constructor() {
        this.parser = document.createElement('a')
        this.supportScriptElement = document.getElementById('supportPageScript')
        this.outletKey = this.supportScriptElement.dataset.outletKey
        this.apiBaseUrl = this.supportScriptElement.dataset.apiBaseUrl

        this.lostCredentialsForm = document.getElementById('lostCredentialsForm')
        this.cancelMembershipForm = document.getElementById('cancelMembershipForm')
        this.cardElement = document.getElementById('card')

        this.setUp()
    }

    setUp() {
        if (this.lostCredentialsForm) {
            this.lostCredentialsForm.addEventListener('submit', this.getCredentials.bind(this))
        }

        if (this.cancelMembershipForm) {
            this.cancelMembershipForm.addEventListener('submit', this.cancelMembership.bind(this))
        }

        if (this.cardElement) {
            this.cardElement.setAttribute('pattern', '[0-9]{4}')
            this.cardElement.addEventListener('keyup', this.validateCard.bind(this))
        }
    }

	getCredentials(e) {
		e.preventDefault()
		alert('Unfortunately we could not locate the credentials for your account. Please get in touch with our support team.')
	}

	cancelMembership(e) {
		e.preventDefault()
		const data = {
			emailAddress: document.getElementById('email').value,
			cardLastFour: document.getElementById('card').value,
			outletKey: this.outletKey
		}
		const url = `${this.apiBaseUrl}/public/customer/stop-subscription`
		this.fetchData(url, 'POST', data).then(res => {
			if (res.status === 200) {
				if (document.getElementById('page-body')) {
					document.getElementById('page-body').innerHTML =
						'Please check your email inbox for confirmation of your cancellation.'
				} else {
					alert('Please check your email inbox for confirmation of your cancellation.')
				}
			} else {
				if (document.getElementById('page-body')) {
					document.getElementById('page-body').innerHTML =
						'We could not find any active membership based on the information provided. Please get in touch with our support team.'
				} else {
					alert('We could not find any active membership based on the information provided. Please get in touch with our support team.')
				}
			}
		})
	}

    fetchData(url, method = 'GET', data) {
        return fetch(url, {
            method,
            headers: method === 'POST' ? {'Content-Type': 'application/json'} : {},
            body: data ? JSON.stringify(data) : null
        }).then(res => res)
    }

    buildQueryString(params) {
        return Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&')
    }

    validateCard() {
        this.cardElement.value = this.cardElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    }
}

(function () {
    window.supportFormHandler = new SupportFormHandler()
})()
